import { render, staticRenderFns } from "./DynamicSvg.vue?vue&type=template&id=5805025e"
import script from "./DynamicSvg.vue?vue&type=script&lang=js"
export * from "./DynamicSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports